import styled from "styled-components";

export const FormWrap = styled.div`
  margin-bottom: 20px;
  padding: 14px 20px 20px;
  background-color: #fdfcfc;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
`;
